import React, { createContext, useContext, useState, useEffect } from 'react';

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
  const [isTestData, setIsTestData] = useState(() => {
    const saved = localStorage.getItem('isTestData');
    return saved === 'true';
  });

  const [soundEnabled, setSoundEnabled] = useState(() => {
    const saved = localStorage.getItem('soundEnabled');
    return saved === 'true'; // Default is false
  });

  const [soundVolume, setSoundVolume] = useState(() => {
    const saved = localStorage.getItem('soundVolume');
    return saved ? parseInt(saved, 10) : 50; // Default 50%
  });

  const [soundInterval, setSoundInterval] = useState(() => {
    const saved = localStorage.getItem('soundInterval');
    return saved ? parseInt(saved, 10) : 30; // Default 30 seconds
  });

  const [keepAwake, setKeepAwake] = useState(() => {
    const saved = localStorage.getItem('keepAwake');
    return saved !== 'false'; // Default true
  });

  useEffect(() => {
    localStorage.setItem('isTestData', isTestData);
    window.dispatchEvent(new CustomEvent('settings-changed', { detail: { isTestData } }));
  }, [isTestData]);

  useEffect(() => {
    localStorage.setItem('soundEnabled', soundEnabled);
  }, [soundEnabled]);

  useEffect(() => {
    localStorage.setItem('soundVolume', soundVolume);
  }, [soundVolume]);

  useEffect(() => {
    localStorage.setItem('soundInterval', soundInterval);
  }, [soundInterval]);

  useEffect(() => {
    localStorage.setItem('keepAwake', keepAwake);
  }, [keepAwake]);

  return (
    <SettingsContext.Provider 
      value={{ 
        isTestData, setIsTestData, 
        soundEnabled, setSoundEnabled, 
        soundVolume, setSoundVolume,
        soundInterval, setSoundInterval,
        keepAwake, setKeepAwake 
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};